import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['button', 'input'];

  connect() {
    this.check()
  }

  check() {
    this.buttonTarget.disabled = this.inputTarget.files.length === 0
  }
}
